import { Machine, assign } from 'xstate';
import { wpFetchRestApi, isWpSuccess, assertEventType } from '../util';
;
;
export const joinMachine = Machine({
    id: 'join',
    initial: 'key_input',
    states: {
        key_input: {
            on: {
                JOIN: 'fetching',
            }
        },
        fetching: {
            invoke: {
                id: 'fetch-join-info',
                src: 'fetchJoinInfo',
                onDone: [
                    { target: 'key_found', cond: 'keyFound', actions: ['assignUrl'] },
                    { target: 'no_key_found' },
                ],
                onError: {
                    target: 'error',
                    actions: assign({
                        error: (___, evt) => evt.data,
                    }),
                },
            },
        },
        key_found: {
            type: 'final',
            entry: ['redirectToUrl'],
        },
        no_key_found: {
            on: {
                JOIN: 'fetching',
            }
        },
        error: {
            on: {
                JOIN: 'fetching',
            }
        },
    },
}, {
    services: {
        fetchJoinInfo: fetchJoinInfo,
    },
    actions: {
        redirectToUrl: redirectToUrl,
        assignUrl: assign({
            url: (__, evt) => evt.data.url,
        }),
    },
    guards: {
        keyFound: (__, evt) => evt.data.url !== null,
    }
});
async function fetchJoinInfo(__, evt) {
    assertEventType(evt, 'JOIN');
    const key = evt.key;
    const endpoint = 'meeting/join/' + key;
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
export function createJoinMachine() {
    return joinMachine.withContext({});
}
function redirectToUrl(ctx) {
    if (ctx.url) {
        window.location.href = ctx.url;
    }
}
